module.exports = "https://p.cds.unp.clasificados.pe/payment-success-oportunity.28fa5c43404c96580bd747967010151f.png";